import { EntityName } from './index';

export interface IFinanceItem {
    entityName: EntityName;
    entityGuid: string;
    name: string;
    amount: number;
    count: number;
}

/**
 * Model to hold event finance details for an Event
 */
export class EventFinances {
    public arenaTotalCollected: number = 0;
    public stripeTotalCollected: number = 0;
    public netAmount: number = 0;
    public totalFees: number = 0;
    public totalRefunded: number = 0;
    public totalDisputed: number = 0;
    public financeItems: IFinanceItem[] = [];

    /**
     * Deserialize from a json api format
     */
    public deserialize(json: any): EventFinances {
        this.arenaTotalCollected = json.arenaTotalCollected;
        this.stripeTotalCollected = json.stripeTotalCollected;
        this.netAmount = json.netAmount;
        this.totalFees = json.totalFees ? json.totalFees * -1 : 0;
        this.totalRefunded = json.totalRefunded ? json.totalRefunded * -1 : 0;
        this.totalDisputed = json.totalDisputed ? json.totalDisputed * -1 : 0;
        this.financeItems = json.financeItems || [];

        // Sort the finance items by type and then name
        this.financeItems.sort((item1: IFinanceItem, item2: IFinanceItem) => {
            const compare1: any = item1.entityName + item1.name;
            const compare2: any = item2.entityName + item2.name;

            if (compare1 > compare2) {
                return 1;
            } if (compare1 < compare2) {
                return -1;
            }

            return 0;
        });

        return this;
    }
}
